import FilterSchema from '../schemas/FilterSchema'

/**
 * @typedef {import('../schemas/FilterSchema').Filter} Filter
 */

/**
 *
 * @param {*} initData
 * @returns {Filter}
 */
export default function FilterVo(initData = {}) {
  return FilterSchema.validateSync(initData)
}
